import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/store/account/group/list",
        component: List,
        name: "store.account.group.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/account/group/create",
        component: Create,
        name: "store.account.group.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/account/group/barcode/edit",
        component: Edit,
        name: "store.account.group.edit",
        meta: {
            requiresAuth: true,
        },
    },
    // { path: '/store/account/group/item/view', component: View, name: 'store.account.group.view',
];
